/**
 * Configuration for how agent actions should be displayed in the workflow run view.
 *
 * Actions in this set will always be expanded (not collapsed) in the UI because they
 * represent important user-visible actions like sending emails or SMS messages.
 */
export const ALWAYS_EXPANDED_ACTION_IDS = new Set(["send_sms_action"]);

/**
 * Determines if an operation should be collapsed in the workflow run view.
 *
 * Operations are collapsed if:
 * - The action is NOT in the always-expanded list
 * - The operation does NOT require review
 * - The operation is NOT a rich action (e.g., validate quote, validate invoice)
 *
 * @param actionId - The ID of the action to check
 * @returns true if the operation should be collapsed, false otherwise
 */
export const shouldCollapseOperation = (actionId: string): boolean => {
  return !ALWAYS_EXPANDED_ACTION_IDS.has(actionId);
};
